import { useSearchParams } from "react-router-dom";
import { BannerHero, Container } from "@/components/site/Layout";
import { ContactRouting } from "@/components/site/ContactRouting";
import { useSeo } from "@/lib/useSeo";
import { OFFICES, EMAILS } from "@/lib/content";

const DIRECT = [
  ["Press", EMAILS.press],
  ["All other inquiries", EMAILS.info],
];

export default function Contact() {
  const [params] = useSearchParams();
  useSeo({ title: "Contact AFR | Community, Partner, Investor & Media Inquiries", description: "Route your question to the right America First Refining team and get a reference number back.", path: "/contact" });
  return (
    <div data-testid="contact-page">
      <BannerHero testId="contact-banner" title="Contact Us" image="/img/afr-tanks-trees.jpg" alt="Rendering of AFR storage tanks at the Brownsville site" caption="Rendering · AFR" intro="For further information, please contact us." />
      <Container testId="contact-body">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8"><ContactRouting key={params.get("audience")} initial={params.get("audience") ?? "community"} /></div>
          <aside className="lg:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#D4A24C]">Direct lines</p>
            <ul className="mt-4 border-t border-white/10">
              {DIRECT.map(([k, v]) => <li key={k} className="flex flex-wrap justify-between gap-2 border-b border-white/10 py-4 text-sm"><span className="font-semibold">{k}</span><a href={`mailto:${v}`} data-testid={`contact-email-${k.split(" ")[0].toLowerCase()}`} className="break-all text-slate-200 underline-offset-2 hover:underline">{v}</a></li>)}
            </ul>
            <p className="mt-10 font-mono text-xs uppercase tracking-[0.2em] text-[#D4A24C]">Offices</p>
            {OFFICES.map((o) => (
              <div key={o.city} data-testid={`office-${o.city.toLowerCase()}`} className="mt-4 border-t border-white/10 pt-4 text-sm text-slate-200">
                <p className="font-display text-2xl font-bold uppercase text-white">{o.city}</p>
                {o.lines.map((l) => <p key={l}>{l}</p>)}
                {o.phone && <a href={`tel:${o.phone.replace(/\D/g, "")}`} className="mt-1 inline-block hover:underline">{o.phone}</a>}
              </div>
            ))}
          </aside>
        </div>
      </Container>
    </div>
  );
}
